import { useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Badge } from '@/components/ui/badge';
import { Gift } from 'lucide-react';

const CHANGELOG = [
  { date: '2026-03-22', title: 'Issue Tracker & Ticket System', description: 'Submit bugs and feature requests directly from the app with automatic page/browser capture.', tag: 'New' },
  { date: '2026-03-22', title: 'Feedback Loop + Network Learning', description: 'Accept/reject AI suggestions now train the global mapping model for improved accuracy.', tag: 'Moat' },
  { date: '2026-03-22', title: 'Tier-Aware Rate Limiting', description: 'Enterprise users get unlimited AI. Pro/Free users have fair-use limits per minute.', tag: 'AI' },
  { date: '2026-03-22', title: 'Real Community Intelligence', description: 'Explainability Panel now shows live accept rates from across the network.', tag: 'Data' },
  { date: '2026-03-22', title: 'AI Caching + Quota Guards', description: 'Schema-hash caching cuts AI costs 60-80%. Credit limits enforced per-operation.', tag: 'Cost' },
  { date: '2026-03-21', title: 'Mapping Health Dashboard', description: 'Monitor drift, broken fields, and auto-repair status across all saved mappings.', tag: 'New' },
  { date: '2026-03-21', title: 'Public Demo (No Auth)', description: 'Interactive demo at /demo showcasing signal detection, field repair, and scoring.', tag: 'PLG' },
  { date: '2026-03-20', title: 'EQ Coach + Sales Methodologies', description: 'Real-time emotional intelligence coaching with Carnegie, Sandler, SPIN & Challenger frameworks.', tag: 'New' },
  { date: '2026-03-19', title: 'Keyboard Shortcuts', description: 'Press ⌘? to see all available shortcuts. Focus mode with ⌘.', tag: 'UX' },
  { date: '2026-03-18', title: 'Field Repair AI', description: 'Auto-detect and fix CRM data mismatches from call transcripts.', tag: 'AI' },
  { date: '2026-03-17', title: 'Voice Intelligence', description: 'Live mic transcription powered by ElevenLabs Scribe v2.', tag: 'Core' },
];

export function WhatsNew() {
  const [seen, setSeen] = useState(() => localStorage.getItem('sf-changelog-seen') === CHANGELOG[0].date);

  const markSeen = () => {
    localStorage.setItem('sf-changelog-seen', CHANGELOG[0].date);
    setSeen(true);
  };

  return (
    <Popover onOpenChange={(o) => { if (o) markSeen(); }}>
      <PopoverTrigger asChild>
        <button className="relative h-8 w-8 flex items-center justify-center rounded-md hover:bg-sidebar-accent transition-colors" title="What's New">
          <Gift className="h-4 w-4 text-sidebar-foreground/60" />
          {!seen && (
            <span className="absolute top-1 right-1 h-2 w-2 rounded-full bg-destructive" />
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-80 p-0" align="end">
        <div className="px-4 py-3 border-b border-border">
          <h3 className="text-[13px] font-bold text-foreground">What's New</h3>
          <p className="text-[10px] text-muted-foreground">{CHANGELOG.length} updates</p>
        </div>
        <div className="max-h-80 overflow-y-auto divide-y divide-border/50">
          {CHANGELOG.map((item, i) => (
            <div key={i} className="px-4 py-3">
              <div className="flex items-center gap-2 mb-1">
                <Badge variant="secondary" className="text-[8px] h-4 px-1.5">{item.tag}</Badge>
                <span className="text-[9px] text-muted-foreground">{item.date}</span>
              </div>
              <p className="text-[12px] font-semibold text-foreground">{item.title}</p>
              <p className="text-[10px] text-muted-foreground mt-0.5">{item.description}</p>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
